import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { formatNumber, Typography } from '@dev/ee-components';
import { ABSummaryProps } from '../ABReadyToInterface';

const CenterRecipientsCount = styled.div`
    display: flex;
    align-items: center;
    justify-contend: space-between;
`;
const Version = styled.div`
    width: 170px;
`;
const WinnerWrapper = styled.div`
    padding: 20px 0;
    display: flex;
    align-items: center;
`;

export const WinnerSummary: FC<ABSummaryProps> = ({ uniqueRecipients, uniqueRecipientsPercent }): JSX.Element => {
    const { t } = useTranslation();

    return (
        <WinnerWrapper>
            <Version>
                <Typography variant="body2" bodyVariant="help">
                    {t('winner')}
                </Typography>
            </Version>
            <CenterRecipientsCount>
                <Typography variant="h4">{`${formatNumber(uniqueRecipients)} ${t('uniquerecipients')}`}</Typography>
                <Typography
                    variant="body2"
                    bodyVariant="help"
                    style={{ marginLeft: '4px' }}
                >{`(${uniqueRecipientsPercent}%)`}</Typography>
            </CenterRecipientsCount>
        </WinnerWrapper>
    );
};
